export default __webpack_public_path__ + "static/media/Beastmaster's Strand of Bones.4d3f8fe0.jpg";